import "./order-card.scss";

import * as React from "react";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEllipsis}      from "@fortawesome/free-solid-svg-icons";

export const OrderCard = ({details, onOptionsClick: handleOptionsClick, orderId, orderName}:{
    details        ?: Array<{label: string, value: React.ReactNode}>,
    onOptionsClick ?: React.MouseEventHandler<HTMLElement>,
    orderId         : string,
    orderName       : string,
}) => (
    <article key={orderId} className="order-card-e218bf">
        <header>
            <div className="titles">
                <span className="title">{orderName}</span>
                <span className="subtitle">Order ID. {orderId}</span>
            </div>
            <button onClick={handleOptionsClick}><FontAwesomeIcon icon={faEllipsis}/></button>
        </header>
        <ul className="details">
            {details?.map(({label, value}) => (
                <li key={label}>
                    <span className="label">{label}</span>
                    <span xd-qa-type="label" xd-qa-name={label}>{value}</span>
                </li>
            ))}
            {undefined}
        </ul>
    </article>
);

